<template>
  <b-modal header-class="ion-bg-modal-header" size="xl"
           centered scrollable no-close-on-backdrop
           v-model="visible">

    <!-- Modal Header -->
    <template #modal-header>
      <div class="fw-bold">{{ $t(`menu.chargeHistory`) }}</div>
    </template>

    <div class="row" v-if="!$_utils.isEmpty(items)">
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">

              <div class="row mb-3 align-items-end">
                <!-- // List PerPage Count -->
                <div class="col-auto">

                </div>
                <!-- // Total Count -->
                <div class="col me-2">
                  <div class="float-end">
                    <total-count :total-count="items.length" />
                  </div>
                </div>
              </div>

              <!-- // List -->
              <div class="table-responsive">
                <b-table class="text-nowrap align-middle" bordered hover
                         show-empty :empty-text="$t('settlement.noData')"
                         :fields="fields" :items="items">

                  <template #head()="data">
                    <span v-if="!$_utils.isEmpty(data.label)">{{ $t(`settlement.${data.column}`) }}</span>
                  </template>

                  <template #cell(configKey)="data">
                    {{ $_formatter.chargingConfigTypeName(data.item.configKey) }}
                  </template>

                  <template #cell(configValue)="data">
                    {{ data.item.configValue }}{{ $_formatter.chargingConfigTypeValue(data.item.configKey) }}
                  </template>

                  <template #cell(beforeDiscountChargeFee)="data">
                    {{ $_utils.comma(data.item.beforeDiscountChargeFee) }}
                  </template>

                  <template #cell(discountRate)="data">
                    {{ $_utils.comma(data.item.discountRate) }}
                  </template>

                  <template #cell(chargeFee)="data">
                    {{ $_utils.comma(data.item.chargeFee) }}
                  </template>

                  <template #cell(authDate)="data">
                    {{ $_formatter.timestampToDate(data.item.authDate) }}
                  </template>

                  <template #cell(chargeTime)="data">
                    {{ $_formatter.timestampToTime(data.item.startTimestamp) }} ~ {{ $_formatter.timestampToTime(data.item.stopTimestamp) }}
                  </template>

                </b-table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <template #modal-footer>
      <div class="w-100 text-end">
        <b-button variant="secondary" class="w-xs p-1" @click="close">
          {{ $t('btn.close') }}
        </b-button>
      </div>
    </template>

  </b-modal>
</template>

<script>
import { http } from '@/auth-api';
import TotalCount from "@/views/components/TotalCount.vue";

export default {
  components: {
    TotalCount
  },
  props: {
    placeId: {
      type: Number
    },
    authDate: {
      type: String,
    }
  },
  data() {
    return {
      visible: false,
      pagination: {
        currentPage: 1,
        totalCount : 0,
        perPage: 50
      },
      searchConditions: [],
      sortDirection: 'DESC',
      fields: [
        { key: 'rnum', label: 'No.', class: 'text-center' },
        { key: 'moid', label: '결제 ID', class: 'text-center' },
        { key: 'placeName', label: '충전소명', class: 'text-center' },
        { key: 'chargeBoxName', label: '충전기명', class: 'text-center' },
        { key: 'chargeBoxId', label: '충전기 ID', class: 'text-center' },
        { key: 'configKey', label: '충전 요청 유형', class: 'text-center' },
        { key: 'configValue', label: '충전 요청', class: 'text-center' },
        { key: 'chargeEnergyKwh', label: '실제 충전 용량', class: 'text-center' },
        { key: 'beforeDiscountChargeFee', label: '충전 금액', class: 'text-center' },
        { key: 'discountRate', label: '할인률', class: 'text-center' },
        { key: 'chargeFee', label: '결제 금액', class: 'text-center' },
        { key: 'appCardName', label: '결제 수단', class: 'text-center' },
        { key: 'authDate', label: '이용일', class: 'text-center' },
        { key: 'chargeTime', label: '충전 시간', class: 'text-center' },
        { key: 'memberName', label: '사용자명', class: 'text-center' },
        { key: 'memberPlanType', label: '회원 플랜', class: 'text-center' },
      ],
      items: null
    }
  },
  methods: {
    show() {
      const vm = this;

      vm.getItems();
      this.visible = true;
    },
    async getItems() {
      const vm = this;
      const _url = '/onmapi/view/Settlement/detail/list';

      vm.searchConditions = [];
      vm.searchConditions.push({ searchKey: 'placeId', searchValue: this.placeId });
      vm.searchConditions.push({ searchKey: 'authDate', searchValue: this.authDate });

      await http.post(_url, {
        page: vm.pagination.currentPage,
        limit: vm.pagination.perPage,
        searchConditions: vm.searchConditions,
        sortCondition: { sortDirection: vm.sortDirection }
      }).then(res => {
        vm.items = res.data.items;
        vm.pagination.totalCount = res.data.totalCount;
      }).catch(err => {
        console.error('Settlement Detail List Error :: ', err)
      }).finally(() => {

      });
    },
    reset() {
      const vm = this;

      vm.items = null;
    },
    close() {
      const vm = this;
      vm.reset();

      this.$emit('callback');
      vm.visible = false;
    },
  }
}
</script>
